function ascendingSortString(list, attr) {
  return list.sort((a, b) => a[attr].localeCompare(b[attr]))
}

function descendingSortString(list, attr) {
  return list.sort((a, b) => b[attr].localeCompare(a[attr]))
}

export { ascendingSortString, descendingSortString }
